module.exports = __webpack_public_path__ + "img/greater-than-equal.9043d450.svg";